<template>
  <section
    v-if="activeCampaign.active && !userIsLoggedIn"
    :class="`${activeBannerColor} lighten-1`"
  >
  <v-container class="white--text">
    <v-row>
      <v-icon color="white" class="mr-2">{{ activeBannerIcon }}</v-icon>
      <h3>{{ activeBannerMessage }}</h3>
    </v-row>
  </v-container>
</section>
</template>

<script>
import { get } from 'lodash';

export default {
  name: 'CampaignBanner',
  computed: {
    activeCampaign() {
      return this.$store.getters.activeCampaign;
    },
    activeBannerColor() {
      return get(this.activeCampaign, 'banner.color', 'green');
    },
    activeBannerMessage() {
      return get(this.activeCampaign, 'banner.message', 'For a limited time only, we are offering a discount on all new memberships!');
    },
    activeBannerIcon() {
      return get(this.activeCampaign, 'banner.icon', 'fa-exclamation-circle');
    },
    userIsLoggedIn() {
      return this.$store.getters.userIsLoggedIn;
    },
  },
};
</script>
